import React from "react";
import { connect } from "react-redux";
import { appendStyle } from "../../Components/Functions";
import { updateSearchParameters } from "../../Redux/SearchEngine/actions";
import AppMap from "./AppMap";

const SearchEngineMap = (props) => {
	React.useEffect(() => {
		appendStyle("assets/css2/app.css");
		appendStyle("assets/css2/main.css");
	}, []);

    const updateSearch = (e) => {
        props.updateSearchParameters({
            map: e,
            latitude: e?.latLng?.lat,
            longitude: e?.latLng?.lng,
        })
    }

	return (
		<div className="dual-container-right">
			<AppMap
				showFeatures={false}
				order={true}
				configure={true}
				hideCircularMenu={true}
				callback={(e) => {
                    updateSearch(e);
				}}
			/>
		</div>
	);
};



const mapStateToProps = ({ search, searchParameters, categories }) => {
	return { searchParameters };
};

const mapDispatchToProps = (dispatch) => {
	return {
		updateSearchParameters: (e) => dispatch(updateSearchParameters(e))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchEngineMap);
